/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdraftdiscardtitle3Inputs */

const en_eventdraftdiscardtitle3 = /** @type {(inputs: Eventdraftdiscardtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard this draft?`)
};

const de_eventdraftdiscardtitle3 = /** @type {(inputs: Eventdraftdiscardtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf verwerfen?`)
};

/**
* | output |
* | --- |
* | "Discard this draft?" |
*
* @param {Eventdraftdiscardtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdraftdiscardtitle3 = /** @type {((inputs?: Eventdraftdiscardtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdraftdiscardtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdraftdiscardtitle3(inputs)
	return de_eventdraftdiscardtitle3(inputs)
});
export { eventdraftdiscardtitle3 as "eventDraftDiscardTitle" }